// Supabase client used for auth + profile writes from the browser.
// Reads REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY from
// Netlify env vars. Both must be set for the login gate to work.
import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.error(
    'Supabase env vars missing: set REACT_APP_SUPABASE_URL and ' +
    'REACT_APP_SUPABASE_ANON_KEY in Netlify and redeploy.'
  );
}

export const supabase = createClient(url || 'https://missing.invalid', anonKey || 'missing');
